var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"clause"}},[_c('div',{staticClass:"title"},[_vm._v("中文知识网用户使用服务协议")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }